import React from "react";
import { AppLayout, SideNavigation, Flashbar, FlashbarProps, BreadcrumbGroup, TopNavigation } from "@cloudscape-design/components";
import { Stage, NAV, Route } from "../../constants";

interface AppShellProps {
  children: React.ReactNode;
  stage: Stage;
  notifications: FlashbarProps.MessageDefinition[];
  activeRoute: Route;
}

const APP_TITLE = "AB Registration Console";

const ROUTE_TO_HREF: Record<Route, string> = {
  "search": NAV.ROUTES.SEARCH,
  "keymaster": NAV.ROUTES.KEYMASTER,
  "redrive": NAV.ROUTES.REDRIVE,
  "sfn-failures": NAV.ROUTES.SFN_FAILURES,
};

const ROUTE_TO_LABEL: Record<Route, string> = {
  "search": NAV.SEARCH,
  "keymaster": NAV.KEYMASTER,
  "redrive": NAV.REDRIVE,
  "sfn-failures": NAV.SFN_FAILURES,
};

export const AppShell: React.FC<AppShellProps> = ({ children, stage, notifications, activeRoute }) => (
  <>
    <TopNavigation
      identity={{ href: NAV.ROUTES.HOME, title: APP_TITLE, logo: { src: "", alt: "" } }}
      utilities={[
        {
          type: "button",
          text: stage.toUpperCase(),
          variant: stage === "prod" ? "primary-button" : "link",
        },
      ]}
    />
    <AppLayout
      navigation={
        <SideNavigation
          header={{ text: NAV.CONSOLE, href: NAV.ROUTES.HOME }}
          items={[
            { type: "link", text: NAV.SEARCH, href: NAV.ROUTES.SEARCH },
            { type: "divider" },
            { type: "link", text: NAV.REDRIVE, href: NAV.ROUTES.REDRIVE },
            { type: "link", text: NAV.SFN_FAILURES, href: NAV.ROUTES.SFN_FAILURES },
            { type: "link", text: NAV.KEYMASTER, href: NAV.ROUTES.KEYMASTER },
          ]}
          activeHref={ROUTE_TO_HREF[activeRoute]}
        />
      }
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: NAV.CONSOLE, href: NAV.ROUTES.HOME },
            { text: ROUTE_TO_LABEL[activeRoute], href: ROUTE_TO_HREF[activeRoute] },
          ]}
        />
      }
      notifications={notifications.length > 0 ? <Flashbar items={notifications} /> : null}
      content={children}
      toolsHide
      navigationWidth={220}
    />
  </>
);
